<template>
<li
    :class="[
        `mdc-deprecated-list-item`,
        selected && 'mdc-deprecated-list-item--selected',
        disabled && 'mdc-deprecated-list-item--disabled',
        hidden && 'custom-hidden',
        separator && 'separator'
    ]"
    :data-value="value"
    :role="role"
    :aria-selected="selected">
    <span class="mdc-deprecated-list-item__ripple"></span>
    <span
        v-if="title && desc"
        class="mdc-deprecated-list-item__text">
        <span
            class="mdc-deprecated-list-item__primary-text"
            v-html="title"></span>
        <span class="mdc-deprecated-list-item__secondary-text">{{
            desc
        }}</span>
    </span>
    <slot
        v-else-if="text"
        name="text"
        :text="text">
        <span
            class="mdc-deprecated-list-item__text"
            v-html="text"></span>
    </slot>
    <span
        v-if="icon"
        class="mdc-deprecated-list-item__meta material-icons"
        aria-hidden="true">
        {{ icon }}
    </span>
</li>
</template>

<script>
export default {
    props: {
        item: { type: Object, default: () => ({}) }
    },
    computed: {
        ...[
            "value",
            "role",
            "selected",
            "disabled",
            "title",
            "desc",
            "text",
            "icon",
            "hidden",
            "separator"
        ].reduce((result, key) => {
            result[key] = {
                get() {
                    return this.item?.[key];
                }
            };
            return result;
        }, {})
    }
};
</script>

<style lang="scss">
.mdc-deprecated-list .custom-hidden {
    display: none;
}
.separator {
    background-color: rgba(0, 0, 0, 0.08);
    height: 1px !important;
}
</style>
